<template>
  <div>
    <div v-if="messages" class="skeletonMessages">
      <div
        v-for="(line, index) in this.messages"
        :key="index"
        class="message-line"
        v-html="`<p>${line}</p>`"
      ></div>
    </div>
    <div id="skeletonParagraph" class="skeleton-paragraph mb-5">
      <div v-if="showTitle" class="skeleton-title"></div>
      <div v-for="index in rows" :key="index" class="skeleton-line"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    rows: {
      type: Number,
      default: 5,
    },
    showTitle: {
      type: Boolean,
      default: true,
    },
    messages: {
      type: Array,
      required: false,
      default: () => []
    },
  },
  methods: {
    getRandomBetween(lowerLimit, upperLimit) {
      return Math.random() * (upperLimit - lowerLimit) + lowerLimit;
    },
    setWidth() {
      const parentElement = document.getElementById("skeletonParagraph");
      const lines = this.$el.querySelectorAll(".skeleton-line");
      const parentWidth = parentElement.clientWidth;

      lines.forEach((element) => {
        element.style.marginRight =
          parentWidth * this.getRandomBetween(0.1, 0.4) + "px";
      });
    },
  },
  mounted() {
    this.setWidth();
  },
};
</script>

<style scoped lang="scss">
.skeleton-paragraph {
  display: flex;
  flex-direction: column;
  gap: 10px;
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;

  & > div {
    border-radius: 9999px;
    background-color: #374151;
  }

  .skeleton-title {
    height: 10px;
    width: 50%;
    margin-bottom: 16px;
  }

  .skeleton-line {
    height: 8px;
  }
}

.skeletonMessages {
  font-size: 12px;
  color: #004583;
  opacity: 0.8 !important;
  font-weight: 700;
  margin-bottom: 20px;
}

.white-content {
  .skeleton-paragraph {
    & > div {
      background-color: #e5e7eb;
    }
  }
}

@keyframes pulse {
  50% {
    opacity: 0.2;
  }
}
</style>
